import axios from 'axios';


const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class PurchaseOrderService {
	async getSupplierProductsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Products/SearchAndSort`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async generatePurchaseOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Clients/PurchaseOrder`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateGeneratedPurchaseOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.put(
				API_URL + `/Clients/PurchaseOrder/${request_data.id}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updatePurchaseOrderStatusAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.put(
				API_URL +
					`/Clients/PurchaseOrder/${request_data.id}/Status?Status=${request_data.status}`,
				{},
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getGeneratedPurchaseOrdersAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Clients/PurchaseOrder/ListFilterAndSort`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getReplenishOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/Inventory/Aggregation`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getBackOrderAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.post(
				API_URL + `/BackOrders/Aggregation`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}

	async confirmProductLnesAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.patch(
				API_URL + `/BackOrders/BackOrderLines`,
				request_data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
}

export default new PurchaseOrderService();